// src/utils/arPresentFormIV_salim.js
// בניין 4 (يُفْعِلُ) - נטיות הווה-עתיד לגזרת השלמים

const DAMMA = '\u064F';
const FATHA = '\u064E';
const KASRA = '\u0650';
const SUKUN = '\u0652';
const SHADDA = '\u0651';
const HARAKAT_RE = /[\u064B-\u065F\u0670]/g;
const NON_ARABIC_LETTERS_RE = /[^\u0621-\u064A]/g;

const PREFIXES = {
  'أَنَا': 'أ' + DAMMA,
  'أَنْتَ': 'ت' + DAMMA,
  'أَنْتِ': 'ت' + DAMMA,
  'هُوَ': 'ي' + DAMMA,
  'هِيَ': 'ت' + DAMMA,
  'نَحْنُ': 'ن' + DAMMA,
  'أَنْتُمْ': 'ت' + DAMMA,
  'أَنْتُنَّ': 'ت' + DAMMA,
  'هُمْ': 'ي' + DAMMA,
  'هُنَّ': 'ي' + DAMMA,
};

const stripHarakat = (value) => (value || '').replace(HARAKAT_RE, '');

function extractRootLetters(root) {
  const cleanRoot = stripHarakat(String(root || '').trim()).replace(NON_ARABIC_LETTERS_RE, '');
  if (cleanRoot.length !== 3) return null;
  return [cleanRoot[0], cleanRoot[1], cleanRoot[2]];
}

export function conjugatePresentFormIV_Salim(root) {
  const radicals = extractRootLetters(root);
  if (!radicals) return null;

  const [R1, R2, R3] = radicals;
  const isNunEnding = R3 === 'ن';
  const stem = R1 + SUKUN + R2 + KASRA + R3;

  return {
    'أَنَا': PREFIXES['أَنَا'] + stem + DAMMA,
    'أَنْتَ': PREFIXES['أَنْتَ'] + stem + DAMMA,
    'أَنْتِ': PREFIXES['أَنْتِ'] + stem + KASRA + 'ينَ',
    'هُوَ': PREFIXES['هُوَ'] + stem + DAMMA,
    'هِيَ': PREFIXES['هِيَ'] + stem + DAMMA,
    'نَحْنُ': PREFIXES['نَحْنُ'] + stem + DAMMA,
    'أَنْتُمْ': PREFIXES['أَنْتُمْ'] + stem + DAMMA + 'ونَ',
    'أَنْتُنَّ': isNunEnding
      ? PREFIXES['أَنْتُنَّ'] + stem + SHADDA + FATHA
      : PREFIXES['أَنْتُنَّ'] + stem + SUKUN + 'نَ',
    'هُمْ': PREFIXES['هُمْ'] + stem + DAMMA + 'ونَ',
    'هُنَّ': isNunEnding
      ? PREFIXES['هُنَّ'] + stem + SHADDA + FATHA
      : PREFIXES['هُنَّ'] + stem + SUKUN + 'نَ',
  };
}

export function conjugatePresentFormIV_Salim_fromRow(row) {
  const binyan = String(row?.['בניין'] || row?.binyan || '').trim();
  const gizra = String(row?.['gizra'] || row?.gzira || row?.['גזרה'] || '').trim();

  if (!(binyan === '4' || binyan === 'בניין 4')) return null;
  if (!gizra.includes('שלמים')) return null;

  return conjugatePresentFormIV_Salim(row?.['שורש'] || row?.root || '');
}
